export const DISMISS_PARTNER_MODAL = 'dismiss-partner-modal';
export const DISMISS_PARTNER_MODAL_COOKIE_NAME = 'partner-modal-dismissed';
const dismissPartnerModal = () => ({ type: DISMISS_PARTNER_MODAL });
export default dismissPartnerModal;
